module.exports = __webpack_public_path__ + "static/img/6.16fe841.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/6.png
// module id = BfA6
// module chunks = 0